(($, Drupal) => {
    Drupal.behaviors.gridtriple = {
        attach: function attach() {
            
            $(".grid-triple__category-wrapper").once("grid-triple").each(function() {
                const gridtriple = $(this);
                gridtriple.find("." + sliderClasses.navContainerClass).addClass('default__nav');
                

                $(window).on("resize load", function() {
                    if(gridtriple.data('owl.carousel')) {
                        if($(window).innerWidth() < 768)
                        {
                            gridtriple.data('owl.carousel').options.margin = 16;
                            gridtriple.data('owl.carousel').options.items = 1;
                            gridtriple.trigger('refresh.owl.carousel');
                        }
                        else if($(window).innerWidth() >= 768 && $(window).innerWidth() < 1280) {
                            gridtriple.data('owl.carousel').options.margin = 32;
                            gridtriple.data('owl.carousel').options.items = 2;
                            gridtriple.trigger('refresh.owl.carousel');
                        }
                        else {
                            gridtriple.data('owl.carousel').options.margin = 32;
                            gridtriple.data('owl.carousel').options.items = 3;
                            gridtriple.data('owl.carousel').options.nav = true;
                            gridtriple.trigger('refresh.owl.carousel');
                        }
                    }
                })

            });
        }
    };

})(jQuery, Drupal);
  